import { render, staticRenderFns } from "./CDLastActiveProjectsSection.vue?vue&type=template&id=6f95f9ed&scoped=true"
import script from "./CDLastActiveProjectsSection.vue?vue&type=script&lang=ts"
export * from "./CDLastActiveProjectsSection.vue?vue&type=script&lang=ts"
import style0 from "./CDLastActiveProjectsSection.vue?vue&type=style&index=0&id=6f95f9ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f95f9ed",
  null
  
)

export default component.exports